import { Route, Routes } from 'react-router';

import { AliviSettingsRouteActions } from './actions/AliviSettingsRouteActions';
import { ClearviewSettingsRouteActions } from './actions/ClearviewSettingsRouteActions';
import { KinetikSettingsRouteActions } from './actions/KinetikSettingsRouteActions';
import { MomentmSettingsRouteActions } from './actions/MomentmSettingsRouteActions';
import { MTMSettingsRouteActions } from './actions/MTMSettingsRouteActions';

export function AdminRouteActions() {
  return (
    <Routes>
      <Route element={<MTMSettingsRouteActions />} path="mtm" />
      <Route element={<MomentmSettingsRouteActions />} path="momentm" />
      <Route element={<KinetikSettingsRouteActions />} path="kinetik" />
      <Route element={<AliviSettingsRouteActions />} path="alivi" />
      <Route element={<ClearviewSettingsRouteActions />} path="clearview" />
    </Routes>
  );
}
